import { render, staticRenderFns } from "./ExcursionHallsForm.vue?vue&type=template&id=31769f36&"
import script from "./ExcursionHallsForm.vue?vue&type=script&lang=js&"
export * from "./ExcursionHallsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports